import { Component, Input } from '@angular/core';
import { DropdownMatterSubtype } from '@safarilaw-webapp/feature/lpms/data-access';
import { FeatureFlag } from '@safarilaw-webapp/shared/environment';
import { SafariFormComponent, SafariFormSection } from '@safarilaw-webapp/shared/ui-kit/safari-form';

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@Component({
  selector: 'sl-lpms-matter-subtype-typeahead',
  templateUrl: './matter-subtype-typeahead.component.html',
  imports: [SafariFormComponent.standaloneImports, TypeaheadModule]
})
export class LpmsMatterSubtypeTypeaheadComponent extends SafariFormSection {
  FeatureFlag = FeatureFlag;

  private _subtypes: DropdownMatterSubtype[];
  public get subtypes(): DropdownMatterSubtype[] {
    return this._subtypes;
  }
  @Input()
  public set subtypes(value: DropdownMatterSubtype[]) {
    this._subtypes = [...value].sort((a, b) => {
      // If they are the same matter type use API's order property
      if (a.matterType == b.matterType) {
        return a.order - b.order;
      }
      // Otherwise we sort by matterType in order (1-DR, 2-GAR, 3-Lit, 4-Oth)
      return a.matterType - b.matterType;
    });
  }
  _matterSubtypeSearchStarted = false;

  // TYPEAHEAD NOTES:  Search teh code for TYPEAHEAD NOTES for a better description.  I'm not going to copy all
  // of that here.
  typeAheadValueChange(event) {
    this._typeaheadHandler(event);
  }

  typeAheadOnBlur(event) {
    if (this._matterSubtypeSearchStarted) {
      this._typeaheadHandler(event);
    }
  }

  private _typeaheadHandler(event: any) {
    if (event?.item?.id != null) {
      this.form.get('matterSubtypeId').setValue(event.item.id);
      this.form.get('matterSubtypePlaceholder').setValue(event.item.name);
    } else {
      this.form.get('matterSubtypeId').setValue(null);
      this.form.get('matterSubtypePlaceholder').setValue(null);
    }
    this.form.get('matterSubtypeName').setValue(null);
    this._matterSubtypeSearchStarted = false;
  }

  matterSubtypeSearchStarted(): void {
    this._matterSubtypeSearchStarted = true;
  }
  getSubtypePlaceHolder() {
    if (this.form.get('matterSubtypePlaceholder').value != null && this.form.get('matterSubtypePlaceholder').value.length > 0) {
      return this.form.get('matterSubtypePlaceholder').value;
    }
    if (this.subtypes.length > 20) {
      return '-- Type Subtype name to search --';
    }
    return '-- Select Subtype --';
  }
}
